export default __webpack_public_path__ + "static/media/11.741b04ea.jpg";